module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "wechat-title",
      rawName: "v-wechat-title",
      value: (_vm.$route.meta.title),
      expression: "$route.meta.title"
    }],
    staticClass: "downloads"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('ul', {
    staticClass: "tab-list"
  }, _vm._l((_vm.tabList), function(tab) {
    return _c('li', {
      key: tab.key,
      class: ['tab-item', _vm.activeTab === tab.key ? 'active' : ''],
      on: {
        "click": function($event) {
          return _vm.changeTab(tab.key)
        }
      }
    }, [_vm._v(_vm._s(tab.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "content"
  }, [_c('downloadContent', {
    attrs: {
      "loading": _vm.loading,
      "item": _vm.tabData,
      "active-tab": _vm.activeTab
    },
    on: {
      "recordUserDownload": _vm.recordUserDownload,
      "containerDeployValidate": _vm.containerDeployValidate
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("下载专区")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("集合蓝鲸各类资源包，含官方套餐，完整包，工具包，证书下载等")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-8174b93c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/downloads/index.vue
// module id = jIoV
// module chunks = 15